<div class="input-checkbox-list">
  @if (formData.label) {
    <label class="input-checkbox-list_label">
      {{ formData.isTranslated ? (formData.label | translate) : formData.label }}

      @if (formData.required) {
        <span class="input-checkbox-list_required">
          *
        </span>
      }
    </label>
  }

  <div class="input-checkbox-list_options">

    @for (
      option of formData.options;
      track option.value
      ) {
      <label
        class="input-checkbox-list_option"
        [class.input-checkbox-list_option--disabled]="
          isLoading || option.disabled
        ">

        <input
          type="checkbox"
          [checked]="isChecked(option.value)"
          [disabled]="isLoading || option.disabled"
          (change)="
            onCheckboxChange(
              option,
              $any($event.target).checked
            )
          "
        />

        <span class="input-checkbox-list__checkbox"></span>

        <span class="input-checkbox-list__text">
          {{ option.isTranslated ? (option.label | translate) : option.label }}
        </span>

      </label>
    }

  </div>
</div>
